import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import FilteredChecksGroup from './../Form/FilteredChecksGroup';
import { startsWith, toPairs, lowerCase } from 'lodash';
import LightSpinnerWrapper from '../../reusable/Wrappers/LightSpinnerWrapper/LightSpinnerWrapper';

class SelectEntitiesFilter extends React.PureComponent {

    static propTypes = {
        switchEntity:     PropTypes.func.isRequired,
        selectedEntities: PropTypes.array
    };

    constructor(props) {
        super(props);

        this.changeEntitySelection = this.changeEntitySelection.bind(this);

        this.state = {
            allCategories: true,
            allUnassigned: true,
            options: this.composeOptions(props)
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            options: this.composeOptions(nextProps)
        });
    }

    composeOptions(props) {
        let entities = toPairs(props.entities);
        return entities.map(option => ({
            key: option[0],
            value:      props.selectedEntities.indexOf(option[0]) > -1,
            label:      option[1]
        })).sort((a, b) => a.label.toLowerCase() > b.label.toLowerCase() ? 1 : a.label.toLowerCase() < b.label.toLowerCase() ? -1 : 0);
    }

    areEntitiesSelected() {
        let entitySelected = false
        this.state.options.forEach(item => (item.value ? entitySelected = true : null))
        return entitySelected
    }

    changeEntitySelection(options, option, e) {
        if (option.value) {
            this.setState({ allCategories: false, options })
        } else {
            if (this.areEntitiesSelected() || this.state.allUnassigned) {
                this.setState({ options });
            } else {
                this.setState({
                    allCategories: true,
                    allUnassigned: true,
                    options
                });
            }
        }
        this.props.switchEntity({ entitiesId: options.filter(option => option.value).map(options => options.key) });
    }

    filterFn(item, filterStr) {
        return lowerCase(item.label).indexOf(lowerCase(filterStr)) > -1 || filterStr === "";
    }

    render() {
        return (
            <div className="select-entities-checkboxes">
                <LightSpinnerWrapper isLoading={!this.state.options.length}>
                    <FilteredChecksGroup
                        placeholderMessageId="General_CoreFunctionality_UIText_find.entity"
                        filterFn={this.filterFn}
                        onChange={this.changeEntitySelection}
                        options={this.state.options} />
                </LightSpinnerWrapper>
            </div>
        );
    }

}

export default injectIntl(SelectEntitiesFilter);



// WEBPACK FOOTER //
// ./src/scripts/reusable/Dropdowns/SelectEntities.filter.jsx